import { Map } from "ol";

export const mapToReadOnly = (map: Map): void => {
  // Remove interactions to make map "readonly"
  const interactionsToRemove = map
    .getInteractions()
    .getArray()
    .map((i) => {
      return i;
    });
  map.getControls().forEach((c) => map.removeControl(c));
  interactionsToRemove?.forEach((i) => map.removeInteraction(i));
};
